/** Шаг 3 оформления: проверка перед подтверждением. */
import type {
  Address,
  CurrentUser,
  VendorPublic,
} from '@arbuz/shared';
import { formatMoney, makeT } from '../../i18n';
import {
  ProductImage,
  SummaryRow,
} from '../clientUi';
import { formatDay } from './helpers';

export function StepReview({
  user,
  vendor,
  address,
  slotDate,
  slotStart,
  selectedSlotEnd,
  itemCount,
  weight,
  comment,
  total,
}: {
  user: CurrentUser;
  vendor: VendorPublic;
  address: Address | null;
  slotDate: string | null;
  slotStart: string | null;
  selectedSlotEnd: string | null;
  itemCount: number;
  weight: { min: number; max: number } | null;
  comment: string;
  total: number;
}) {
  const t = makeT(user.locale);

  return (
    <>
      <h1 className="h1">{t('confirmTitle')}</h1>
      <article className="client-card client-summary-card" style={{ marginTop: 'var(--s-4)' }}>
        {/* Кто везёт — первое, что нужно проверить перед подтверждением:
            в маркетплейсе это отдельный человек со своими ценами */}
        <SummaryRow icon="delivery" label={t('vendorLabel')}>
          {vendor.display_name}
        </SummaryRow>
        <SummaryRow icon="location" label={t('addressTitle')}>
          {address?.address_text ?? '—'}
        </SummaryRow>
        <SummaryRow icon="calendar" label={t('slotTitle')}>
          {slotDate ? formatDay(slotDate, user.locale) : '—'}
          <br />
          {slotStart ? `${slotStart}${selectedSlotEnd ? `–${selectedSlotEnd}` : ''}` : '—'}
        </SummaryRow>
        <SummaryRow icon="watermelon" label={t('quantityTitle')}>
          {itemCount} {t('pcs')} {weight ? `(${weight.min} – ${weight.max} ${t('kg')})` : ''}
        </SummaryRow>
        {comment && (
          <SummaryRow icon="comment" label={t('commentLabel')}>
            {comment}
          </SummaryRow>
        )}
      </article>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 96px', gap: 'var(--s-3)', alignItems: 'end', marginTop: 'var(--s-10)' }}>
        <div>
          <p className="muted" style={{ margin: 0, fontSize: 'var(--fs-sm)' }}>
            {t('totalToPay')}
          </p>
          <h2 style={{ margin: 'var(--s-1) 0 0', fontSize: 'var(--fs-h1)' }}>
            {formatMoney(String(total), user.locale)} {t('sum')}
          </h2>
        </div>
        <ProductImage />
      </div>
    </>
  );
}

